import { FC, useCallback, useMemo } from 'react';
import {
  FullAnswerBody,
  FullArticleBody,
  GPTQuestion,
  PartialAnswerBody,
  PartialArticleBody,
} from '../../shared/component';
import { useAtomValue } from 'jotai';
import {
  $CurrentExperienceAnswerAsAvailable,
  $CurrentExperienceAnswerFold,
  $CurrentExperienceStandardKeyword,
} from '../../shared/atoms';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';
import { ClickPosition } from '~/utils/click-position';
import { AiAuthor } from '../../shared/component/ai-author';
import { ExperienceSourceArticleList } from '../experience-source-article-list';

export const ExperienceMainInfo: FC = () => {
  const { answerContent, isNumber, question, articleFullContent, isNewType } = useAtomValue(
    $CurrentExperienceAnswerAsAvailable,
  );
  const standardKeyword = useAtomValue($CurrentExperienceStandardKeyword);
  const isFold = useScopedAtomValue($CurrentExperienceAnswerFold);
  const { isBot } = useAtomValue($UserAgent);

  const displayedTitle = useMemo(() => {
    return question ? question : standardKeyword;
  }, [question, standardKeyword]);

  const experienceContentRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_module_show', {
        current_page_module: ModuleType.experience_content,
      });
      window.Tea('wap_cta_show', {
        current_page_module: ModuleType.experience_content,
        current_position: ClickPosition.experience_question,
        is_cta: 0,
      });
    }, []),
  });

  const renderFoldedContent = (): JSX.Element => {
    return (
      <>
        {isNewType ? (
          <PartialArticleBody shortContent={articleFullContent} />
        ) : (
          <PartialAnswerBody stepContent={answerContent} isNumber={isNumber} />
        )}
      </>
    );
  };

  const renderFullContent = (): JSX.Element => {
    return (
      <>
        {isNewType ? (
          <FullArticleBody fullContent={articleFullContent} />
        ) : (
          <FullAnswerBody stepContent={answerContent} isNumber={isNumber} />
        )}
      </>
    );
  };

  return (
    <div className="experience-main-info" ref={experienceContentRef}>
      <GPTQuestion question={displayedTitle} />
      {isBot && <AiAuthor />}
      {isBot && <ExperienceSourceArticleList />}
      {isFold && !isBot ? renderFoldedContent() : renderFullContent()}
    </div>
  );
};
